import { render, staticRenderFns } from "./BookmarksCard.vue?vue&type=template&id=76d0d897"
import script from "./BookmarksCard.vue?vue&type=script&lang=js"
export * from "./BookmarksCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports